import React from "react";
import { connect } from "react-redux";
import { login, register } from "../../../redux/modules/auth";
import { createErrorNotification } from "../../../redux/modules/notifications";
import "./login-page.css";

interface LoginPageProps {
  login?: (login: string, password: string) => void;
  register?: (login: string, password: string) => void;
  createErrorNotification?: (message: string) => void;
}

interface LoginPageState {
  password: string;
  login: string;
}

class LoginPage extends React.Component<LoginPageProps, LoginPageState> {
  constructor(props: LoginPageProps) {
    super(props);
    this.state = { password: "", login: "" };
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    const value = e.target.value.toLowerCase();
    if (field === "password") {
      this.setState({ password: value });
    } else if (field === "login") {
      this.setState({ login: value });
    }
  };

  handleSubmit = () => {
    if (!this.state.login || !this.state.password) {
      this.props.createErrorNotification && this.props.createErrorNotification("Пароль і логін не можуть бути порожніми");
      return;
    }
    this.props.login && this.props.login(this.state.login, this.state.password);
  };

  handleRegister = () => {
    this.props.register && this.props.register(this.state.login, this.state.password);
  };

  render() {
    return (
      <div className="login-page">
        <div className="login-page__container">
          <div className="login-page__header">
            <div className="login-page__icon">✨</div>
            <h1 className="login-page__title">Гігея</h1>
            <p className="login-page__subtitle">Ласкаво просимо до системи управління</p>
          </div>
          <form onSubmit={(e) => e.preventDefault()} className="login-page__form">
            <div className="login-page__form-group">
              <label htmlFor="loginPageLogin" className="login-page__label">
                Логін
              </label>
              <input
                onChange={(event) => this.handleChange(event, "login")}
                type="text"
                className="login-page__input"
                id="loginPageLogin"
                value={this.state.login}
                placeholder="Введіть логін"
              />
            </div>
            <div className="login-page__form-group">
              <label htmlFor="loginPagePassword" className="login-page__label">
                Пароль
              </label>
              <input
                onChange={(event) => this.handleChange(event, "password")}
                type="password"
                className="login-page__input"
                id="loginPagePassword"
                value={this.state.password}
                placeholder="Введіть пароль"
              />
            </div>
            <div className="login-page__actions">
              <button type="submit" className="login-page__btn-submit" onClick={this.handleSubmit}>
                <span className="login-page__btn-icon">🔐</span>
                Увійти
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default connect(null, { login, register, createErrorNotification })(LoginPage);
